module.exports = __webpack_public_path__ + "static/media/keyboard.ebdfde12.svg";